import type * as CSS from 'csstype';

import { type Utility } from '../types/utility';

export interface RadiiVariants {
  /** @returns `5px` */
  base: CSS.Property.BorderRadius;
  /** @returns `8px` */
  button: CSS.Property.BorderRadius;
  /** @returns `8px` */
  card: CSS.Property.BorderRadius;
  /** @returns 4px */
  checkbox: CSS.Property.BorderRadius;
  /** @returns `2px` */
  form: CSS.Property.BorderRadius;
  /** @returns `8px` */
  paper: CSS.Property.BorderRadius;
  /** @returns `4px` */
  textOnly: CSS.Property.BorderRadius;
}

export type Radii = RadiiVariants &
  Utility.VariantModes<{
    [K in RadiiVariantsType]: CSS.Property.BorderRadius;
  }>;

const base: RadiiVariants = {
  base: '5px',
  button: '8px',
  card: '8px',
  checkbox: '4px',
  form: '2px',
  paper: '8px',
  textOnly: '4px',
};

const radii: Radii = {
  ...base,
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base,
  },
};

export type RadiiVariantsType = 'base' | 'button' | 'card' | 'checkbox' | 'form' | 'paper' | 'textOnly';
export const radiiVariants = Object.keys(base) as RadiiVariantsType[];

export default radii;
